import { DatePickerElement } from 'react-hook-form-mui';

export default DatePickerElement;
